



















import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';

import { getDefaultDestinationContract, OptiState } from '@/store/modules/opti';

const opti = namespace('opti');
@Component
export default class MoreDestination extends Vue {
  @opti.State destinationContracts!: OptiState['destinationContracts'];
  @opti.Mutation addDestination: any;
  @opti.Mutation setActiveDestination: any;
  openIndex = 0;

  get destinationCount() {
    return this.destinationContracts.length;
  }
  moreDestination() {
    this.addDestination(getDefaultDestinationContract());
    this.setActiveDestination(this.destinationContracts.length - 1);
    this.$router.push('2');
  }
  next() {
    this.$router.push('4');
  }
}
